module.exports = __webpack_public_path__ + "media/fonts/avenir/Avenir-Book-f582ab51ffcea894bf255818fb4b7b8a.woff";